// extracted by mini-css-extract-plugin
module.exports = {"laserCanvas":"LaserCanvas_laserCanvas__3o1p4","covered":"LaserCanvas_covered__2XVCb"};